import {useEffect, useState} from "react";
import {Permission, Role} from "../../types/userTypes";
import {RoleForm} from "../custom-components/UserComponents/RoleForm";
import {createRole, getAvailablePermissions, getRoleById, updateRole} from "@/queries/userQueries";
import {enqueueSnackbar} from "notistack";
import {useNavigate, useSearchParams} from "react-router-dom";
import {getSubRoot} from "@/utils/utils";

const RoleForgePage = () => {
    const [availablePermissions, setAvailablePermissions] = useState<Permission[]>([])
    const [role, setRole] = useState<Role | null>(null)
    const [mode, setMode] = useState<'create' | 'update'>('create')
    const [searchParams, setSearchParams] = useSearchParams();

    const navigate = useNavigate();

    const loadAvailablePermissions = async () => {
        try{
            const permissions = await getAvailablePermissions()
            setAvailablePermissions(permissions)
        }catch (e){
            console.error(e)
            enqueueSnackbar("Error loading available permissions")
        }
    }

    const loadRole = async (roleId: string) => {
        try{
            const role = await getRoleById(roleId)
            setRole(role)
        }catch (e){
            console.error(e)
            enqueueSnackbar("Error loading selected Role")
        }
    }

    useEffect(() => {
        loadAvailablePermissions()
        const roleId = searchParams.get("id");
        if(roleId){
            setMode('update')
            loadRole(roleId)
        }else{
            setMode('create')
        }
    }, []);

    const onRoleSave = async (role: any) => {
        try{
            if(mode === 'create'){
                const response = await createRole(role)
                setRole({...role, id: response.id})
                setMode('update')
                setSearchParams({id: response.id})
            }else{
                await updateRole(role.id, role);
            }
            enqueueSnackbar(`Role ${mode === 'create' ? 'created' : 'updated'} successfully`)
        }catch(err){
            console.log(err);
            enqueueSnackbar("Error Saving the role")
        }
    }

    const onRoleCancel = async () => {
        navigate(`${getSubRoot(window.location.pathname)}/users`, )
    }

    return <RoleForm availablePermissions={availablePermissions} initialRole={role} onSave={onRoleSave} onCancel={onRoleCancel}/>
}

export default RoleForgePage;